<template>
	<div class="flex items-center justify-between w-full ms-pagination">
		<div class="postion-pagination flex">
			<span class="total-info">
				<div class="flex">
					{{ `${$t('i18nComponent.TotalItem')}: ` }}
					<strong class="ml-2" v-if="!isLoadingTotalRecord">{{
						(pageSize > pageTotal ? pageTotal : pageSize) + '/' + pageTotal
					}}</strong>
					<div v-else class="ml-2">
						<div class="loading-total"></div>
					</div>
				</div>
			</span>
			<span
				class="ml-16"
				v-if="pageButtomValue && pageButtomValue.length > 0"
				v-for="item in pageButtomValue"
				:key="item.Id"
			>
				{{ item.Name }}
				<strong>{{ item.Value | formatNumber({ maxDigits: 6 }) }}</strong>
			</span>
			<div class="flex ml-8" v-if="pagingTemplate">
				<component
					:is="pagingTemplate.template"
					:data="data"
					v-bind="pagingTemplate.props"
				></component>
			</div>
		</div>
		<div class="flex left-pagination align-center">
			<div class="flex items-center mr-2">
				<ms-combobox
					class="mr-2 page-size hy-32"
					:data="recordInPageStore"
					valueField="value"
					displayField="display"
					v-model="pageSize"
					readonly
					@selected="loadPageIndex(1)"
				></ms-combobox>
			</div>
			<div class="mr-5 flex items-center">
				<div>
					{{ $t('i18nCommon.From') }}
					<span class="font-bold">{{
						`${dataRender == 0 ? 0 : (pageIndex - 1) * pageSize + 1}`
					}}</span>
					{{ $t('i18nCommon.to') }}
					<span class="font-bold">{{
						`${(pageIndex - 1) * pageSize + dataRender}`
					}}</span>
					{{ $t('i18nCommon.record') }}
				</div>
				<div
					@click="previousPage"
					:class="{ disableText: disablePrevPage }"
					class="ml-4 cursor-pointer unselect"
				>
					<div class="">
						<div
							class="mi mi-24 mi-icon-pre-page"
							:class="{ 'mi-icon-disabled-pre-page': disablePrevPage }"
						></div>
					</div>
				</div>
				<div
					@click="nextPage"
					:class="{ disableText: disableNextPage }"
					class="ml-4 cursor-pointer unselect"
				>
					<div class="">
						<div
							class="mi mi-24 mi-icon-next-page"
							:class="{
								'mi-icon-disabled-next-page':
									disableNextPage || isLoadingTotalRecord,
							}"
						></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import MSStore from '@/store/msstore';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';

export default {
	name: 'msPagination',
	props: {
		dataRender: {
			default: 0,
			type: [Number, String],
		},
		/**
		 * Tổng số bản ghi của dữ liệu
		 */
		pageTotal: {
			default: 0,
			type: [Number, String],
		},
		pageIndexCurrent: {
			default: 1,
			type: Number,
		},
		pagingTemplate: {},
		data: {},
		pageButtomValue: {
			type: Array,
			return: () => [],
		},
		isLoadingTotalRecord: {
			default: false,
			type: Boolean,
		},
	},
	computed: {
		/**
		 * Tổng số trang theo pageSize hiện tại của grid
		 */
		totalPages() {
			return Math.ceil(this.pageTotal / this.pageSize);
		},
		disableNextPage() {
			if (this.pageIndex >= this.totalPages && !this.useServerSide) {
				return true;
			}
			return false;
		},
		disablePrevPage() {
			if (this.pageIndex <= 1) {
				return true;
			}
			return false;
		},
	},
	data() {
		const me = this;
		return {
			pageSize: me.$ms.commonFunc.getTakePageSize(),
			pageIndex: 1,
			recordInPageStore: [
				{
					value: 20,
					display: '20',
				},
				{
					value: 30,
					display: '30',
				},
				{
					value: 50,
					display: '50',
				},
				{
					value: 100,
					display: '100',
				},
			],
		};
	},
	mounted() {},
	methods: {
		//Load lại page theo số trang.
		loadPageIndex(index) {
			const me = this;
			if (!index || index <= 0) {
				index = 1;
				me.pageIndex = 1;
			} else {
				me.pageIndex = index;
			}
			let payload = {
				skip: (index - 1) * me.pageSize,
				take: me.pageSize,
			};
			me.$ms.commonFunc.setTakePageSize(me.pageSize);
			//Phát sự kiện global load lại pageSize cho các grid đã khởi tạo
			EventBusGlobal.$emit(GlobalEventName.LoadPageSizeGrid, me.pageSize);
			me.$emit('loadData', payload);
		},
		nextPage() {
			const me = this;
			if (!me.disableNextPage && !me.isLoadingTotalRecord) {
				me.loadPageIndex(this.pageIndex + 1);
			}
		},
		firstPage() {
			const me = this;
			if (!me.disablePrevPage) {
				me.loadPageIndex(1);
			}
		},
		lastPage() {
			const me = this;
			if (!me.disableNextPage) {
				me.loadPageIndex(me.totalPages);
			}
		},
		previousPage() {
			const me = this;
			if (!me.disablePrevPage) {
				me.loadPageIndex(this.pageIndex - 1);
			}
		},
		loadPageInfoIndex(index) {
			const me = this;
			if (!index || index <= 0) {
				index = 1;
				me.pageIndex = 1;
			} else {
				me.pageIndex = index;
			}
			let payload = {
				skip: (index - 1) * me.pageSize,
				take: me.pageSize,
			};
			me.$emit('loadPageInfoIndex', payload);
		},
	},
	watch: {
		pageIndexCurrent: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				me.pageIndex = newVal || 1;
			},
		},
	},
};
</script>
<style scoped lang='scss'>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msPagination.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msPagination.scss';
}
</style>

